module.exports = __webpack_public_path__ + "img/12.62751148.jpg";